module.exports = __webpack_public_path__ + "static/img/logohome.3f73744.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logohome.png
// module id = vFGG
// module chunks = 1